<div class="header-container flex">
  <div class ="header-item"><img src="./assets/logo1.png" alt="Wicked Infinity Publishing Logo"></div>
</div>

<div class="displayTable">
    <div class="displayTableCell">
      <div class="authBlock">
        <h2>Log In</h2>
        <div class="formGroup">
          <input type="text" class="formControl" placeholder="Email" #userName required #passwordResetEmail required>
        </div>
        <div class="formGroup">
          <input type="password" class="formControl" placeholder="Password" #userPassword required>
        </div>
        <!-- Calling SignIn Api from AuthService -->
        <div class="formGroup">
          <input type="button" class="secondary-button" value="Forgot Password" (click)="authService.resetPassword(passwordResetEmail.value)">
          <input type="submit" class="primary-button" value="Log in" (click)="authService.signIn(userName.value, userPassword.value)">
      </div>
    </div>
  </div>